import {
  createAnalytics,
  createWebEventFactory,
  createEventStreamClient,
  createEventStreamSink,
  consoleSink,
  Sink,
  EventStreamEndpoint,
  createDomMutationDelegate,
  installWindowLifecycleListeners,
  installDocumentTitleListener,
  utmParameters,
  refTagParameters,
  clickIdParameters,
} from '@amzn/ring-web-analytics';
import { config } from 'src/config';
import { isLocalBuild } from 'src/utils/constants';
import { NeighborsCustomDimensions } from './types';

const ALLOW_PARAMETERS = [
  ...utmParameters,
  ...refTagParameters,
  ...clickIdParameters,
  'utm_campaignid',
  'locationId',
  'neighborhoodId',
  'refSessId',
];

function buildSink(): Sink {
  if (isLocalBuild) {
    return consoleSink;
  }

  return createEventStreamSink(
    createEventStreamClient({
      window,
      endpoint: config.RWA_EVENT_STREAM_URL as EventStreamEndpoint,
      group: 'client.device',
      subgroup: 'ring.neighbors.webapp',
    }),
  );
}

export function initializeRWA(): void {
  if (!config.RWA_ENABLED || window.RWA) {
    return;
  }

  try {
    window.RWA = createAnalytics<NeighborsCustomDimensions>({
      window,
      clientId: 'RingNeighborsWebAssets',
      awsRegion: 'us-east-1',
      cookieDomain: '.ring.com',
      referrer: window.document.referrer,
      sink: buildSink(),
      isTesting: false,
      eventFactory: createWebEventFactory<NeighborsCustomDimensions>({
        makeContext: (dimensions) => ({ locale: dimensions.locale }),
        includeQueryString: {
          allowParameters: ALLOW_PARAMETERS,
        },
      }),
      customDimensions: {
        locale: navigator.language || 'en-US',
      },
    });

    const domMutationDelegate = createDomMutationDelegate(window);
    installDocumentTitleListener(domMutationDelegate, window, window.RWA);
    installWindowLifecycleListeners(window, window.RWA);
    domMutationDelegate.invoke();
  } catch (error) {
    console.error('Failed to initialize RWA:', error);
  }
}
